// The "using this" toggle shows on every resource EXCEPT codex records — a codex record is a dictionary-style
// entry, not a thing a person "uses". Matches on either the STI `type` ("Item::CodexRecord") or GraphQL
// `__typename` ("ItemCodexRecord"). Kept as a zero-dep leaf so it's unit-testable without the component graph.
const CODEX_TYPES = ["Item::CodexRecord", "ItemCodexRecord"]

/** Whether a resource shows the "using this" toggle (everything but codex records). */
export const showsUsingToggle = (
  type?: string | null,
  typename?: string | null
): boolean =>
  !CODEX_TYPES.includes(type ?? "") && !CODEX_TYPES.includes(typename ?? "")
